module.exports = __webpack_public_path__ + "img/icon_tips@2x.ad7e6058.png";